import { REQUEST_TYPES } from '../requestTypes';
import { ENTITY_NAMES } from '../entityNames';
import { ENDPOINTS } from '../../../config/config';
import { type RequestHandlerFactory } from '../../types';

export const dataPrivacyRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.GET_DATA_PRIVACY_CONFIG]: () => {
        const entity = ENTITY_NAMES.DATA_PRIVACY_CONFIG;

        return {
            transformResponse: response => {
                return response;
            },
            descriptors: {
                [entity]: {
                    method: 'get',
                    url: `/dashboard/config/data-privacy`,
                    defaultEndpoint: ENDPOINTS.BASE_URL,
                    data: {}
                }
            }
        };
    }
};
